import { CollectionState, FiltersMap, OptionalFiltersMap } from '@wix/bex-core';

export interface UseCollectionComponentBaseParams<
  T,
  F extends FiltersMap = OptionalFiltersMap,
> {
  /**
   * An instance of [CollectionState](/pages/cairo/?path=/story/common-state--collectionstate), can be initialized using [useCollection](/pages/cairo/?path=/story/common-hooks--usecollection) hook.
   */
  collection: CollectionState<T, F>;
}
